import axios_api from "src/api/axios";
import { prompt } from "src/utils/prompt";

export function useTableLoadRecords() {
    return ({ handleState = (key, value) => { }, url = "", search}) => {
        let params = search ? search : {
            limit: process.env.REACT_APP_PAGINATION_LIMIT,
            page: 0,
        };
        handleState("loading", true);
        axios_api.get(url, { params: { ...params } })
            .then(({ data }) => {
                if (data["result"] !== "success") {
                    handleState("records", []);
                    return prompt.error("unable to load records");
                }
                handleState("records", data["records"]);
                handleState("tcount", data["tcount"]);
            })
            .catch((error) => {
                handleState("records", []);
                handleState("tcount", 0);
                prompt.error("unable to load records");
            })
            .finally(() => {
                handleState("loading", false);
            });
    }
}